import { Weather, Forecast } from './weather';
import { Time } from '@angular/common';

export class WeatherData {
    weather: Weather;
    forecast: Forecast[];
    forecastYrno: Forecast[];
    city: string;
    cityID: string;
    refreshtime: Date;
    weatherForecastSchema?: any;
}
